// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"6e593c07","767":"476311ab"}[chunkId] + ".chunk.js";
};